import { render, staticRenderFns } from "./ManagingParserValues.vue?vue&type=template&id=39a89464&"
import script from "./ManagingParserValues.vue?vue&type=script&lang=js&"
export * from "./ManagingParserValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports